import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {MetricsSection} from '/constant/TestIDs';
import {
  REPORT_EXPIRING_REWARDS,
  REPORT_EXPIRING_WELLNESS,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

export function useExpiringSection({
  expiringCreditsCountFrontline,
  expiringRewardsCountFrontlineOrg,
  onShowInfoPopover,
  onShowReport,
}: any) {
  const {tt, ts} = useTranslation('screen.clients.section.expiring');
  const featureFlag = useSelector(variablesFeatureFlag);
  const removeExpiringRewards = shouldReleaseFeature(
    get(featureFlag, 'ff_Remove_Expiring_Rewards', ''),
  );
  let listItems = [];

  if (!removeExpiringRewards) {
    listItems.push({
      label: tt('rewards', 'Clients with Expiring Rewards'),
      value: expiringRewardsCountFrontlineOrg,
      recordsName: REPORT_EXPIRING_REWARDS,
      testID: MetricsSection.metricFrontlineClientsExpiringRewards,
    });
  }
  listItems.push({
    label: tt('credits', 'Clients with Expiring Wellness Credits'),
    value: expiringCreditsCountFrontline,
    recordsName: REPORT_EXPIRING_WELLNESS,
    testID: MetricsSection.metricOrganizationClientsExpiringWellnessCredits,
  });

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Expiring In The Next 14 Days'),
      body: tt(
        'info.body',
        !removeExpiringRewards
          ? 'These Clients might need attention. Check out who has unused Wellness Credits or who has expiring Rewards for an upcoming Premier. Maybe reach out to remind them that these items could provide savings on their next order?'
          : 'These Clients might need attention. Check who has unused Wellness Credits for an upcoming Premier+. Maybe reach out to remind them that these items could provide saving on their next order.',
      ),
    });

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({recordsName, loadingData: {total: value}});

  return {listItems, onInfoPress, onItemPress, tt, ts};
}
